import React from 'react';

import { isEqual } from 'lodash';

import { siteIds } from '../../../constants';
import { siteId, brandSite } from '../../../sites';

import ViinimaaGoogleTagManager from './viinimaa';

function GoogleTagManager(props) {
  if (isEqual(siteId, siteIds.Viinimaa)) {
    return <ViinimaaGoogleTagManager {...props} />;
  }
  if (isEqual(siteId, siteIds.Folkofolk)) {
    return <ViinimaaGoogleTagManager {...props} />;
  }
  if (brandSite) {
    return <ViinimaaGoogleTagManager {...props} />;
  }

  return null;
}

export default GoogleTagManager;
